import {isInProductionMode, projectUrl} from "../../Config/SharedConfig";

export const getRedirectUrl = (username, token = "") => {
    return [
        isInProductionMode ? 'https://' : 'http://',
        `${username}.${projectUrl}`,
        (token && !isInProductionMode) ? `?token=${token}` : ""
    ].join("")
}